import { lazy } from "react";
// Create Clinical Note — creación de nota (generación previa a
// clinical-notes-v2, todavía expuesta en el menú Tools).
const CreateClinicalNote = lazy(() => import("./CreateClinicalNote"));
export const createClinicalNoteRoutes = [
  { path: "/CreateClinicalNote", element: <CreateClinicalNote /> },
];

export { CreateClinicalNote };
